import rest from './rest';
import events from './events';
import Device from '@/models/device';


async function load() {
  const devices = Object.values(await rest.get('/diodes'));
  for await (const device of devices) {
    device.heartbeat = await events.last(device.serial);
  }
  Device.create({data: devices});
}

async function refresh() {
  for await (const device of Device.all()) {
    device.heartbeat = await events.last(device.serial);
    device.$save();
  }
}

async function register(serial, name, location) {
  const device = await rest.put(`/diodes/${serial}`, {name, location});
  Device.insertOrUpdate({data: device});
}

export default {
  load,
  refresh,
  register
};
